<ng-container [ngSwitch]="report_type">
  <app-projeto-relatorio-1 *ngSwitchCase="1"
                            [report_1_param_1]="report_1_param_1" [report_3_param_1]="report_3_param_1" [report_type]="report_type"
                            [filter_question]="filter_question" [filter_agency]="filter_agency">
  </app-projeto-relatorio-1>
  <app-projeto-relatorio-2 *ngSwitchCase="2"
                            [report_1_param_1]="report_1_param_1" [report_3_param_1]="report_3_param_1" [report_type]="report_type"
                            [filter_question]="filter_question" [filter_agency]="filter_agency">
  </app-projeto-relatorio-2>
  <app-projeto-relatorio-3 *ngSwitchCase="3"
                            [report_1_param_1]="report_1_param_1" [report_3_param_1]="report_3_param_1" [report_type]="report_type"
                            [filter_question]="filter_question" [filter_agency]="filter_agency">
  </app-projeto-relatorio-3>
  <app-projeto-relatorio-4 *ngSwitchCase="4"
                            [report_1_param_1]="report_1_param_1" [report_3_param_1]="report_3_param_1" [report_type]="report_type"
                            [filter_question]="filter_question" [filter_agency]="filter_agency">
  </app-projeto-relatorio-4>
</ng-container>